'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import HubPicker from 'hub-pickers-lib/components/HubPicker';
import { getRedirectQuery, getNextRedirectUrl } from '../utils/urls';

class HomeContainer extends Component {
  render() {
    const {
      filter,
      location: {
        query
      }
    } = this.props;
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "INDEX_LOAD",
      children: /*#__PURE__*/_jsx(HubPicker, {
        redirectTo: getNextRedirectUrl(query),
        filter: filter,
        shouldWarnAboutObscured: true,
        query: getRedirectQuery(query)
      })
    });
  }

}

HomeContainer.propTypes = {
  filter: PropTypes.string,
  userId: PropTypes.number,
  filterAccounts: PropTypes.func,
  location: PropTypes.shape({
    query: PropTypes.object
  })
};

const mapStateToProps = state => ({
  filter: state.accounts.get('filter'),
  userId: state.auth.user.user_id
});

export default connect(mapStateToProps, {})(HomeContainer);